module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/5ae26aa80ec6d5f2e99aa90ee1a3a5cd.png";